import store from '@/store'

export default [
  {
    path: '/questions',
    name: 'question',
    meta: { requiresAuth: true },
    component: () => import('@/pages/eschool/e-exam/question/index.vue')
  },
  {
    path: '/questions/create',
    name: 'question-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/eschool/e-exam/question/create.vue')
  },
  {
    path: '/questions/:id/edit',
    name: 'question-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/eschool/e-exam/question/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('eschool/eExam/question/find', to.params.id)
      next()
    }
  }
]
